import React, { useState, useMemo, useEffect, useRef, setEditQ, setEditIdx, useContext } from 'react';
import threeDots from "../assets/images/dots-vertical.svg";
import ReactDOM from 'react-dom';
// import '../assets/style/lywo-style.css';
import _, { set } from "lodash";
// import '../assets/style/lywo-style2.css';
import { Play, BarChart2, Edit3, ChevronDown, ArrowUpDown, Sparkles, Save, BookCheck, DownloadIcon } from 'lucide-react';
import { Table } from 'antd';
import { PostCallWithErrorResponse, simpleGetCall, simpleGetCallWithErrorResponse } from '../Api/ApiServices';
import { ApiConfig } from '../Api/ApiConfig';
import { toastMsg } from '../component/toast';
import { difficultyLevel } from '../constant/dificultyLevel';
import { retry } from '@reduxjs/toolkit/query';
import { Edit, Delete } from 'lucide-react';
import { SquarePen, Trash, User, Download, Replace } from 'lucide-react';
import AiGenerator from './generateQuestionFromAi';
import Reorder from './Reorder';
import { useNavigate } from 'react-router-dom';
import ReorderQuestionsList from './Reorder';
import { formatToDDMMYYYY } from '../common';
import { AppContext } from '../context/AppContext';
import StatusBadge from '../component/StsusBadge';
import {  Tooltip } from "antd";
import FileSaver from 'file-saver';
import InlineTitleEditor from '../component/QuizTitle';


const Icons = {
  Edit: (p) => <svg {...p} width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" /><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" /></svg>,
  Trash: (p) => <svg {...p} width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="3 6 5 6 21 6" /><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" /></svg>,
  Play: (p) => <svg {...p} width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polygon points="5 3 19 12 5 21 5 3" /></svg>,
  Chart: (p) => <svg {...p} width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="18" y1="20" x2="18" y2="10" /><line x1="12" y1="20" x2="12" y2="4" /><line x1="6" y1="20" x2="6" y2="14" /></svg>,
  Sparkles: (p) => <svg {...p} width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L12 3Z" /><path d="M5 3v4" /><path d="M9 5H3" /><path d="M19 19v2" /><path d="M21 20h-2" /></svg>,
  Grid: (p) => <svg {...p} width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="3" width="7" height="7" /><rect x="14" y="3" width="7" height="7" /><rect x="14" y="14" width="7" height="7" /><rect x="3" y="14" width="7" height="7" /></svg>,
  List: (p) => <svg {...p} width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="8" y1="6" x2="21" y2="6" /><line x1="8" y1="12" x2="21" y2="12" /><line x1="8" y1="18" x2="21" y2="18" /><line x1="3" y1="6" x2="3.01" y2="6" /><line x1="3" y1="12" x2="3.01" y2="12" /><line x1="3" y1="18" x2="3.01" y2="18" /></svg>,
  Upload: (p) => <svg {...p} width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /><polyline points="17 8 12 3 7 8" /><line x1="12" y1="3" x2="12" y2="15" /></svg>,
  Check: (p) => <svg {...p} width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="20 6 9 17 4 12" /></svg>,
  Refresh: (p) => <svg {...p} width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="23 4 23 10 17 10" /><polyline points="1 20 1 14 7 14" /><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15" /></svg>,
  More: (p) => <svg
    {...p}
    width="1.3em"
    height="1.3em"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
  >
    <circle cx="12" cy="12" r="1" />
    <circle cx="12" cy="5" r="1" />
    <circle cx="12" cy="19" r="1" />
  </svg>
  ,
  Close: (p) => <svg {...p} width="1em" height="1em" style={{fontSize:'var(--font-size-h4)'}} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>,
  Download: (p) => <svg {...p} width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /><polyline points="7 10 12 15 17 10" /><line x1="12" y1="15" x2="12" y2="3" /></svg>,
  File: (p) => <svg {...p} width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" /><polyline points="14 2 14 8 20 8" /><line x1="16" y1="13" x2="8" y2="13" /><line x1="16" y1="17" x2="8" y2="17" /><polyline points="10 9 9 9 8 9" /></svg>,
  Plus: (p) => <svg {...p} width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" /></svg>,
  Copy: (p) => <svg {...p} width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="9" y="9" width="13" height="13" rx="2" ry="2" /><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" /></svg>,
  Replace: (p) => <svg {...p} width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="23 4 23 10 17 10" /><polyline points="1 20 1 14 7 14" /><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15" /></svg>,
  Regenerate: (p) => <svg {...p} width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 2v6h-6" /><path d="M3 12a9 9 0 0 1 15-6.7L21 8" /><path d="M3 22v-6h6" /><path d="M21 12a9 9 0 0 1-15 6.7L3 16" /></svg>,
  User: (p) => <svg {...p} width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" /><circle cx="12" cy="7" r="4" /></svg>,
  Brain: (p) => <svg {...p} width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9.5 2A2.5 2.5 0 0 1 12 4.5v15a2.5 2.5 0 0 1-4.96.44 2.5 2.5 0 0 1-2.96-3.08 3 3 0 0 1-.34-5.58 2.5 2.5 0 0 1 1.32-4.24 2.5 2.5 0 0 1 1.98-3A2.5 2.5 0 0 1 9.5 2Z" /><path d="M14.5 2A2.5 2.5 0 0 0 12 4.5v15a2.5 2.5 0 0 0 4.96.44 2.5 2.5 0 0 0 2.96-3.08 3 3 0 0 0 .34-5.58 2.5 2.5 0 0 0-1.32-4.24 2.5 2.5 0 0 0-1.98-3A2.5 2.5 0 0 0 14.5 2Z" /></svg>
};

/* ==============================================================================================
   2. MOCK SERVICES & DATA
   ============================================================================================== */

const JOB_DESCRIPTIONS = [
  {
    title: "Frontend Developer",
    subTopics: ["React", "CSS Grid", "JavaScript ES6", "Accessibility", "Performance Optimization", "Redux", "TypeScript", "Jest", "Webpack", "HTML5 Semantics"]
  },
  {
    title: "Backend Engineer",
    subTopics: ["Node.js", "Express", "MongoDB", "SQL Optimization", "REST APIs", "GraphQL", "Microservices", "Docker", "AWS Lambda", "Redis"]
  },
  {
    title: "DevOps Specialist",
    subTopics: ["CI/CD Pipelines", "Kubernetes", "Terraform", "Linux Administration", "Bash Scripting", "Azure DevOps", "Monitoring (Prometheus)", "Security Best Practices"]
  }
];

const DURATION_OPTIONS = [5, 10, 15, 20, 25, 30, 40, 45, 60];

/* --- START: JOB DESCRIPTION DATA (Copy for Live Project) --- */
const MOCK_JDS = [
  { id: 1, title: 'Senior Frontend Developer (React)', topics: ['Frontend', 'React', 'JavaScript', 'CSS', 'Web Performance'] },
  { id: 2, title: 'Backend Engineer (Node.js)', topics: ['Backend', 'Node.js', 'API Design', 'Database', 'Security'] },
  { id: 3, title: 'DevOps Engineer', topics: ['DevOps', 'AWS', 'Docker', 'Kubernetes', 'CI/CD'] },
  { id: 4, title: 'UI/UX Designer', topics: ['Design', 'Figma', 'Prototyping', 'User Research', 'Accessibility'] },
  { id: 5, title: 'Full Stack Developer', topics: ['Frontend', 'Backend', 'Database', 'API Design', 'Deployment'] }
];
/* --- END: JOB DESCRIPTION DATA --- */



const MockService = {
  simulateAi: (type, payload) => new Promise(resolve => {
    setTimeout(() => {
      const qTemplate = (i, topic) => ({
        id: crypto.randomUUID(),
        text: `AI Question ${i + 1} regarding ${topic}`,
        type: 'MCQ',
        weight: 1,
        rationale: "AI generated rationale explaining the correct answer.",
        options: [{ id: crypto.randomUUID(), text: 'Option A' }, { id: crypto.randomUUID(), text: 'Option B' }, { id: crypto.randomUUID(), text: 'Option C' }, { id: crypto.randomUUID(), text: 'Option D' }],
        correctOptionId: '',
        topics: ['AI', topic]
      });
      const fixCorrectId = (q) => { q.correctOptionId = q.options[0].id; return q; };
      if (type === 'GET') resolve({ questions: Array(parseInt(payload.count)).fill(0).map((_, i) => fixCorrectId(qTemplate(i, payload.topic))) });
      if (type === 'REPLACE') resolve({ question: fixCorrectId(qTemplate(99, 'Replacement')) });
      if (type === 'REGENERATE') resolve({ question: fixCorrectId({ ...qTemplate(99, 'Regen'), text: `Regenerated: ${payload.feedback}` }) });
    }, 800);
  })
};

/* ==============================================================================================
   3. SHARED COMPONENTS (FIXED MODAL)
   ============================================================================================== */

const Modal = ({ title, onClose, children, footer, size = '950px', heightSize = '650px', dialogClassName = '' }) => (
  <div className="custom-modal-overlay">
    <div className={`custom-modal-dialog ${dialogClassName}`} style={{ maxWidth: size, height: heightSize }}>
      <div className="custom-modal-header">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', width: '100%' }}>
          <div style={{ flex: 1 }}>{title}</div>
          <button onClick={onClose} className="text-muted" style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '0 4px 4px 4px'}} title="Close"><Icons.Close /></button>
        </div>
      </div>
      <div className="custom-modal-body">{children}</div>
      {footer && <div className="custom-modal-footer">{footer}</div>}
    </div>
  </div>
);

const Toast = ({ msg }) => (
  <div className="anim-fade" style={{ position: 'fixed', bottom: 20, right: 20, background: 'var(--brand-dark-grey)', color: '#fff', padding: '10px 20px', borderRadius: '8px', zIndex: 1200, fontSize: 'var(--font-size-h4)', boxShadow: '0 4px 12px rgba(0,0,0,0.15)' }}>
    {msg}
  </div>
);

const UserBadge = ({ user }) => {
  return <span className="badge badge-secondary" style={{ display: 'inline-flex', alignItems: 'center', gap: '4px' }} title={`Updated by: ${user}`}><Icons.User style={{ fontSize: '0.9em' }} /> {user}</span>;
};

// --- Shared Navigation Header ---
const ViewNavigation = ({ view, setView, onCreate }) => (
  <div style={{ display: 'flex', alignItems: 'center', width: '100%', gap: '8px' }}>
    {/* Quiz List Title */}
    <div className="canLisTxtStyl mb-0">
      <p className="m-0" style={{ fontWeight: 'bold' }}>Quiz List</p>
    </div>
    <div style={{ flexGrow: 1 }} />
    <div className="d-flex align-items-center">
      {/* Toggle Section */}
      <div className="d-flex align-items-center gap-3">
        <span className="text-sm text-muted fw-medium">Available</span>
        <label className="custom-switch-wrap m-0">
          <div className="position-relative d-flex align-items-center">
            <input
              type="checkbox"
              className="switch-input"
              checked={view === 'active'}
              onChange={() => setView(view === 'dashboard' ? 'active' : 'dashboard')}
            />
            <span className="switch-slider"></span>
          </div>
        </label>
        <span className="text-sm text-dark fw-medium">Deployed</span>
      </div>
    </div>
    <button
      onClick={onCreate}
      className="btn btn-primary"
      title="Create a new quiz"
      style={{

        display: 'block',
        marginLeft: 'auto',
        marginRight: '0'
      }}
    >
      New Quiz
    </button>
  </div>
)

const dropdownItemStyle = {
  display: 'flex', alignItems: 'center', gap: '1rem',
  padding: '8px 12px', width: '100%', border: 'none',
  background: 'transparent', textAlign: 'left',
  fontSize: 'var(--font-size-h4)', color: 'var(--brand-dark-grey)',
  cursor: 'pointer', transition: 'background 0.2s'
};

/* ==============================================================================================
   4. FEATURE VIEWS
   ============================================================================================== */

// --- Dashboard (Drafts) ---
const DashboardView = ({ assessments, onEdit, onDelete, view, setView, onNew ,onAction, handleDownloadQuiz}) => {
  const [viewMode, setViewMode] = useState('list');
  const [showDelete, setShowDelete] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [filteredInfo, setFilteredInfo] = useState({});

  const {adminData} = useContext(AppContext)

  const onDownload = (record) => {
    console.log("Downloading record:", record);
    // Add your download logic here
  };

  const [data,setData] = useState([]);

  // १. डेटा मॅपिंग करून डमी डेटा जोडला (Added dummy data logic)
  
  const getData=()=>{

    simpleGetCall(ApiConfig.GET_QUIZ_LIST+'Draft'+`&email=${adminData?.email}`).then((res)=>{

      if(res?.succeded){
       setData(res?.response)
      }

   })

  }

  useEffect(()=>{

    getData();
  },[])

  const filterData = (data) => (formatter) =>
    data.map((item) => ({
      text: formatter(item),
      value: formatter(item),
    }));


    const deleteQuiz = (id) => {

     simpleGetCallWithErrorResponse(ApiConfig.DELETE_QUIZ_BY_ID+id).then((res)=>{

        if(res?.json?.succeded){
          toastMsg('success',"Quiz deleted successfully");
          getData();
        }else{
          toastMsg('error',"Failed to delete quiz");
        }

     })      

    }

  const handleDownload = () => {
    // Use window.location.origin to make sure it looks in the right place
    const fileUrl = `${window.location.origin}/document_name.pdf`;

    const link = document.createElement('a');
    link.href = fileUrl;
    link.target = "_blank"; // Opens in new tab if download fails
    link.download = "My_Document.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  const columns = [
    {
      title: "Quiz Title",
      dataIndex: "quizName",
      key: "quizName",
      width: "18%",
      sorter: (a, b) => a.quizName.localeCompare(b.quizName),
      filters: _.uniqWith(filterData(data)((i) => i.quizName), _.isEqual),
      onFilter: (value, record) => record.quizName?.toString().includes(value),
      filterSearch: true,
      render: (_, record) => (
        <span className="font-size-base text-dark-brand">{record.quizName}</span>
      ),
    },
    // {
    //   title: "Quiz Title",
    //   dataIndex: "quizName",
    //   key: "quizName",
    //   width: "18%",
    //   sorter: (a, b) => a.quizName.localeCompare(b.quizName),
    //   filters: _.uniqWith(filterData(data)((i) => i.quizName), _.isEqual),
    //   onFilter: (value, record) => record.quizName?.toString().includes(value),
    //   render: (_, record) => (
    //     <span className="font-size-base text-dark-brand">{record.quizName}</span>
    //   ),
    // },
    {
      title: "Company Name",
      dataIndex: "companyName",
      key: "companyName",
      width: "18%",
      isHidden:adminData.admin!='Admin',
      sorter: (a, b) => a.companyName.localeCompare(b.companyName),
      filters: _.uniqWith(filterData(data)((i) => i.companyName), _.isEqual),
      filteredValue: filteredInfo.companyName || null,
      onFilter: (value, record) => record.companyName?.toString().includes(value),
      filterSearch: true,
      render: (_, record) => (
        <span className="font-size-base text-dark-brand">{record.companyName}</span>
      ),
    },
    {
      title: "Author",
      dataIndex: "createdBy",
      key: "createdBy",
      width: "18%",
      isHidden:adminData.admin!='Admin',
      sorter: (a, b) =>(a?.createdBy || "").localeCompare(b?.createdBy || ""),
      render: (_, record) => (
        <span className="font-size-base text-dark-brand">{record?.createdBy}</span>
      ),
    },
    // {
    //   title: "Company Name",
    //   dataIndex: "company",
    //   key: "company",
    //   width: "25%",
    //   sorter: (a, b) => (a.company || "").localeCompare(b.company || ""),
    //   filters: _.uniqWith(filterData(data)((i) => i.company), _.isEqual),
    //   onFilter: (value, record) => record.company?.includes(value),
    //   render: (company) => <span className="text-mid-muted">{company || "TCS Digital"}</span>,
    // },
    // {
    //   title: "Designation",
    //   dataIndex: "position",
    //   key: "position",
    //   width: "18%",
    //   sorter: (a, b) => (a.position || "").localeCompare(b.position || ""),
    //   filters: _.uniqWith(filterData(data)((i) => i.position), _.isEqual),
    //   onFilter: (value, record) => record.position?.includes(value),
    //   render: (pos) => pos || "Developer",
    // },
    {
      title: "Questions",
      dataIndex: "noOfQuestions",
      key: "noOfQuestions",
      width: 120,
      sorter: (a, b) => (a.noOfQuestions || 0) - (b.noOfQuestions || 0),
      filters: _.uniqWith(filterData(data)((i) => i.noOfQuestions), _.isEqual),
      onFilter: (value, record) => record.noOfQuestions === value,
      render: (_, record) => (
        <span className="text-mid-muted">{record.noOfQuestions|| 0} Qs</span>
      ),
    },
    {
      title: "Duration",
      dataIndex: "durationMinutes",
      key: "duration",
      width: 120,
      sorter: (a, b) => (a.duration || 0) - (b.duration || 0),
      filters: _.uniqWith(filterData(data)((i) => i.duration), _.isEqual),
      onFilter: (value, record) => record.duration === value,
      render: (_, record) => (
        <span className="text-mid-muted">{record.duration || 0} m</span>
      ),
    },
    // --- UPDATED DATE COLUMN (REPLACED CREATED DATE) ---
    {
      title: "Updated Date",
      dataIndex: "createdAt",
      key: "createdAt",
      width: 200,
      sorter: (a, b) => new Date(a.createdAt || a.createdAt) - new Date(b.createdAt || b.createdAt),

      filters: _.uniqWith(filterData(data)((i) => formatToDDMMYYYY(i.createdAt ,'dd-mm-yy HH:mm')), _.isEqual),
      onFilter: (value, record) => formatToDDMMYYYY(record.createdAt,'dd-mm-yy HH:mm') === value,
      render: (date, record) => {
        const actualDate =  record.createdAt; // Use createdAt if updatedAt is null
        if (!actualDate) return "-";
 
        return formatToDDMMYYYY(actualDate,'dd-mm-yy HH:mm');
      },
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      width: 120,
      sorter: (a, b) => (a.status || "").localeCompare(b.status || ""),
      filters: [{ text: 'Draft', value: 'draft' }, { text: 'Published', value: 'published' }],
      onFilter: (value, record) => record.status?.toLowerCase() === value,
      render: (status) => {
        const isDraft = status?.toLowerCase() === "draft";
        return (
          <span className="fw-bold" style={{
            fontSize: "var(--font-size-sm)", borderRadius: "12px", padding: "3px 8px",
            backgroundColor: isDraft ? 'var(--color-warning-bg)' : 'var(--color-info-bg)', color: isDraft ? 'var(--color-warning-text)' : "#6287f6",
          }}>
            {status }
          </span>
        );
      },
    },
    {
      title: "Actions",
      key: "actions",
      width: 100,
      align: "center",
      // fixed: 'right',
      // onCell: () => (),
      render: (_, record) => (
        <div className="dropdown">
          <img
            src={threeDots}
            alt="Actions"
            type="button"
            id={`dropdownMenuButton-${record.key}`}
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            className="cursor-pointer"
          />
          <div
            className="dropdown-menu"
            aria-labelledby={`dropdownMenuButton-${record.key}`}
          >
            <a
              className="dropdown-item"
              style={{ fontSize: 'var(--font-size-base)', fontFamily: 'var(--ff-font-family-inter)' }}
            // onClick={() => handleEdit(record)}
            onClick={() => onAction(record, 'adjust')}
            >
              <SquarePen size={14} style={{ marginRight: 7 }} />
              Edit
            </a>
            <a
              className="dropdown-item"
              style={{ fontSize: 'var(--font-size-base)', fontFamily: 'var(--ff-font-family-inter)' }}
            onClick={() => deleteQuiz(record?.quizId)}
            >
              <Trash size={14} style={{ marginRight: 7 }} />
              Delete
            </a>
             <a
              className="dropdown-item"
              style={{ fontSize: 'var(--font-size-base)', fontFamily: 'var(--ff-font-family-inter)' }}
            onClick={() => handleDownloadQuiz(record?.quizId,record?.quizName)}
            >
              <DownloadIcon size={14} style={{ marginRight: 7 }} />
              Download Quiz
            </a>
          </div>
        </div>
      ),
    },
  ].filter((i)=>!i.isHidden);

  return (
    <div className=" d-flex flex-column w-100" style={{}}>
      <div className="panel-header" style={{ padding: '12px 20px', }}>
        <ViewNavigation view={view} setView={setView} onCreate={onNew} />
      </div>

      <div className="panel-body-custom" style={{ flex: 1, padding: '0' }}>
       
          <div className="assessment-table w-100" style={{ marginTop: '-2px', padding: "0 16px",
border: "1px solid var(--ui-border)",
borderTop:" none",
borderRadius: '0 0 8px 8px',
            
           }}>
            <Table
              size="middle"
              columns={columns}
              dataSource={data}
              rowKey="id"
              pagination={false}
              className="grouplisttable overFlowTable w-100 interRegular"
              style={{ width: '100%', margin: 0, overflowX: 'hidden',height:"calc(100vh - 180px)" }}
            />
          </div>
      
      </div>

      {showDelete && (
        <div className="d-flex align-items-center justify-content-center" style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.35)', zIndex: 9999 }}>
          <div style={{ borderRadius: '12px', width: '400px', padding: '15px' }}>
            <div className="fw-semibold" style={{ marginBottom: '12px' }}>Confirm Delete</div>
            <div style={{ marginBottom: '20px' }}>Are you sure you want to delete this?</div>
            <div className="d-flex justify-content-end" style={{ gap: '10px' }}>
              <button className="btn btn-primary" onClick={() => { onDelete(deleteId); setShowDelete(false); }}>OK</button>
              <button
                className="btn btn-outline-primary "
                onClick={() => setShowDelete(false)}

              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

// --- Deployed (Active) ---
const DeployedView = ({ assessments, submissions, onAction, onDelete, view, setView, onNew,handleDownloadQuiz }) => {
  const [viewMode, setViewMode] = useState('list');
  const [filteredInfo, setFilteredInfo] = useState({});

  const [active,setActive] = useState([]);

  const {adminData} = useContext(AppContext)

  // const active = assessments.filter(a => a.status === 'Deployed');

  const getActiveQuiz =()=>{

    simpleGetCall(ApiConfig.GET_QUIZ_LIST+'Ready'+`&email=${adminData?.email}`).then((res)=>{

       if(res?.succeded){
        setActive(res?.response)
       }

    })

  }

  useEffect(()=>{
    getActiveQuiz()
  },[])

  const filterData = (data, key) => {
    return _.uniqBy(
      data.map((item) => ({
        text: item[key] || 'N/A',
        value: item[key] || '',
      })),
      'value'
    );
  };

  const handleChange = (pagination, filters, sorter) => {
    setFilteredInfo(filters);
  };

  const deleteQuiz = (id) => {

    simpleGetCallWithErrorResponse(ApiConfig.DELETE_QUIZ_BY_ID+id).then((res)=>{

       if(res?.json?.succeded){
         toastMsg('success',"Quiz deleted successfully");
         getActiveQuiz();
       }else{
         toastMsg('error',"Failed to delete quiz");
       }

    })      

   }


  const handleDownload = () => {
    // Use window.location.origin to make sure it looks in the right place
    const fileUrl = `${window.location.origin}/document_name.pdf`;

    const link = document.createElement('a');
    link.href = fileUrl;
    link.target = "_blank"; // Opens in new tab if download fails
    link.download = "My_Document.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const columns = useMemo(() => {
   let cols= [
    {
      title: 'Quiz Title',
      dataIndex: 'quizName',
      key: 'quizName',
      width: "18%",
      sorter: (a, b) => a.title.localeCompare(b.title),
      filters: filterData(active, 'quizName'),
      filteredValue: filteredInfo.quizName || null,
      onFilter: (value, record) => record.quizName?.includes(value),
      filterSearch: true,
      render: text => <span className='font-size-base text-dark-brand'>{text}</span>,
    },
    {
      title: 'Company Name',
      dataIndex: 'companyName',
      key: 'companyName',
      isHidden:adminData.admin!='Admin',
      width: "10%",
      sorter: (a, b) => (a.companyName || "").localeCompare(b.companyName || ""),
      filters: filterData(active, 'companyName'),
      filteredValue: filteredInfo.companyName || null,
      onFilter: (value, record) => record.companyName === value,
      filterSearch: true,
      render: val => <span className='font-size-base'>{val || 'N/A'}</span>,
    },
    {
      title: "Author",
      dataIndex: "createdBy",
      key: "createdBy",
      width: "10%",
      isHidden:adminData.admin!='Admin',
      sorter: (a, b) =>(a?.createdBy || "").localeCompare(b?.createdBy || ""),
      render: (_, record) => (
        <span className="font-size-base text-dark-brand">{record?.createdBy}</span>
      ),
    },
 {
  title: "Candidates",
  dataIndex: "candidatesAttempted",
  key: "candidates",
  width: 120,

  sorter: (a, b) =>
    Number(a.candidatesAttempted || 0) -
    Number(b.candidatesAttempted || 0),

  filters: [
    ...new Set(
      active.map((item) => Number(item.candidatesAttempted || 0))
    ),
  ]
    .sort((a, b) => a - b)
    .map((value) => ({
      text: String(value),
      value,
    })),

  filteredValue: filteredInfo.candidates || null,

  onFilter: (value, record) =>
    Number(record.candidatesAttempted || 0) === Number(value),

  render: (value) => (
    <span className="font-size-base">
      {value || 0}
    </span>
  ),
},
    {
  title: "Usage Count",
  key: "userCount",
  width: 120,

  sorter: (a, b) =>
    (a.attachedCodes?.length || 0) - (b.attachedCodes?.length || 0),

  filters: _.uniqBy(
    active.map((item) => ({
      text: String(item.attachedCodes?.length || 0),
      value: item.attachedCodes?.length || 0,
    })),
    "value"
  ),

  filteredValue: filteredInfo.userCount || null,

  onFilter: (value, record) =>
    (record.attachedCodes?.length || 0) === value,

  render: (_, record) => (
    <span className="text-mid-muted">
      {record.attachedCodes?.length || 0}
    </span>
  ),
},
    {
  title: "Access Codes",
  dataIndex: "attachedCodes",
  key: "attachedCodes",
  width: "15%",

  filters: _.uniqBy(
    active.flatMap(item =>
      (item.attachedCodes || []).map(code => ({
        text: code,
        value: code,
      }))
    ),
    "value"
  ),

  filteredValue: filteredInfo.attachedCodes || null,
  isHidden:adminData.admin!='Admin',

  onFilter: (value, record) =>
    record.attachedCodes?.includes(value),

  render: (_, record) => {
    const codes = record.attachedCodes || [];
    const visibleCodes = codes.slice(0, 2);
    const remainingCodes = codes.slice(2);

    return (
      <div className="d-flex flex-wrap gap-1">
        {visibleCodes.map((code) => (
          <StatusBadge key={code} status={code} />
        ))}

        {remainingCodes.length > 0 && (
          <Tooltip
            title={
              <div className="d-flex flex-wrap gap-1">
                {
                  remainingCodes.join(',')
                }
                {/* {remainingCodes.map((code) => (
                  <StatusBadge key={code} status={code} />
                ))} */}
              </div>
            }
          >
            <span className="cursor-pointer text-primary">
              +{remainingCodes.length} more
            </span>
          </Tooltip>
        )}
      </div>
    );
  },
},

    {
      title: 'Date and Time',
      dataIndex: 'createdAt',
      key: 'createdAt',
      width: '180px',
      align: 'left',
      sorter: (a, b) => new Date(a.createdAt) - new Date(b.createdAt),
      // filters: _.uniqBy(
      //   active.map(a => {
      //     const date = new Date(a.createdAt);
      //     const dateStr = `${String(date.getDate()).padStart(2, '0')}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getFullYear()).slice(-2)}`;
      //     return { text: dateStr, value: dateStr };
      //   }),
      //   'value'
      // ),
      filters: _.uniqBy(
        active.map((i) => {
          const formattedDate = formatToDDMMYYYY(
            i.createdAt,
            "dd-mm-yy HH:mm"
          );
      
          return {
            text: formattedDate,
            value: formattedDate,
          };
        }),
        "value"
      ),
      filteredValue: filteredInfo.createdAt || null,
      onFilter: (value, record) => {
        return formatToDDMMYYYY(record?.createdAt,'dd-mm-yy HH:mm') === value;
      },
      render: (date) => {

        return (
          <span className="font-size-base text-start">
            {formatToDDMMYYYY(date,'dd-mm-yy HH:mm')}
          </span>
        );
      },
    },
    {
      title: 'Actions',
      key: 'actions',
      width: 150,
      align: 'center',
      render: (_, record) => (
        <div className="dropdown">
          <img
            src={threeDots}
            alt="Actions"
            type="button"
            id={`dropdownMenuButton-${record.key}`}
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            className="cursor-pointer"
          />
          <div
            className="dropdown-menu"
            aria-labelledby={`dropdownMenuButton-${record.key}`}
          >
            <a
              className="dropdown-item"
              style={{ fontSize: 'var(--font-size-base)', fontFamily: 'var(--ff-font-family-inter)' }}
              onClick={() => onAction(record, 'adjust')}
            >
              <SquarePen size={14} style={{ marginRight: 7 }} />
              Edit
            </a>
            {/* <a
              className="dropdown-item"
              style={{ fontSize: 'var(--font-size-base)', fontFamily: 'var(--ff-font-family-inter)' }}
              onClick={() => deleteQuiz(record?.quizId)}
            >
              <Trash size={14} style={{ marginRight: 7 }} />
              Delete
            </a> */}
            <a
              className="dropdown-item"
              style={{ fontSize: 'var(--font-size-base)', fontFamily: 'var(--ff-font-family-inter)' }}
            onClick={() => handleDownloadQuiz(record?.quizId,record?.quizName)}
            >
              <DownloadIcon size={14} style={{ marginRight: 7 }} />
              Download Quiz
            </a>
          </div>
        </div>
      ),
    }
    
  ]

  return cols.filter((i)=>!i?.isHidden)

}, [onAction, filteredInfo, active, submissions]);

  return (
    <div className=" d-flex flex-column w-100" style={{}}>
      <div className="panel-header" style={{ padding: '12px 20px' }}>
        <ViewNavigation view={view} setView={setView} onCreate={onNew} />
      </div>

      <div className="panel-body-custom" style={{ flex: 1, padding: '0' }}>
        <div className="assessment-table w-100" style={{ marginTop: '-2px', padding: "0 16px",
          border: "1px solid var(--ui-border)",
borderTop:" none",
borderRadius: '0 0 8px 8px',
         }}>
          <Table
            size="middle"
            columns={columns}
            dataSource={active}
            rowKey="id"
            onChange={handleChange}
            className="grouplisttable overFlowTable w-100 interRegular"
            pagination={{ pageSize: 10000000, size: 'small' }}
            style={{ width: '100%', margin: 0, overflowX: 'hidden',height:"calc(100vh - 180px)" }}
          />
        </div>
      </div>
    </div>
  );
};

// --- Editor (Create/Edit) ---
const EditorView = ({ assessment, onSave, onCancel }) => {
  const [local, setLocal] = useState(JSON.parse(JSON.stringify(assessment)));
  const [editQ, setEditQ] = useState(null);
  const [editIdx, setEditIdx] = useState(-1);
  const [aiModalOpen, setAiModalOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [difficulty, setDifficulty] = useState('Medium');

  const [selectedJobData,setSelectedJobData] = useState({
    type:'',
    id:'',
    description:''
  })
  
  const [isEditQstn,setIsEditQstn] = useState(false)

  const [isReOrder, setIsOrder] = useState(false)

  const navigate = useNavigate();

  const [isValided, setIsValided] = useState(false)
  const [showAddMenu, setShowAddMenu] = useState(false);
  const [showSaveMenu, setShowSaveMenu] = useState(false);
  const aiGenWrapperRef = useRef(null);

  const updateQ = (idx, field, val) => {
    const qs = [...local.questions]; qs[idx][field] = val;
    setLocal({ ...local, questions: qs });
  };



  const addQuestion = () => {
    const newId = crypto.randomUUID();
    const optId = crypto.randomUUID();
    const newQ = {
      text: 'New Question',
      type: 'MCQ',
      weight: 1,
      "q": "",
      "options": [
        "",
        "",
        "",
        ""
      ],
      "correct_answer": null,
      "rationale": ""
    }
    // setLocal(prev => ({ ...prev, questions: [...prev.questions, newQ] }));
    setEditQ(newQ);
    setEditIdx(local.questions.length);
  };

  const handleAiImport = (generatedQuestions) => {

    setLocal(prev => ({ ...prev, questions: [...prev.questions, ...generatedQuestions] }));
    setAiModalOpen(false);
  };

  const handleValidation = () => {

    let isValided = false

    if (!editQ?.q?.trim()) {


      isValided = true
    }

    editQ?.options.forEach(opt => {

      if (!opt.trim()) {
        isValided = true
      }

    })

    if (!isValided && !editQ?.correct_answer) {

      toastMsg('error', 'Please select the correct answer.')

      isValided = true

    }



    setIsValided(isValided)
    return isValided

  }


  const saveModalChanges = () => {


    if (editIdx > -1 && editQ) {


      if (handleValidation()) return


      const qs = [...local.questions];

      qs[editIdx] = editQ;
      setLocal({ ...local, questions: qs });
    }
    setEditQ(null);
    setEditIdx(-1);
    setIsValided(false)
  };



  const handleQuestionUpdateFromAi = (type = "more like this", index = 0, question = '', topics = []) => {

    let payload = {
      difficulty_level: 'medium',
      job_description: '',
      question: question,
      topics: topics,
    }


    if (type == 'more like this') {
      payload.num_questions = 2
    }

    if (type == 'Replace') {
      payload.num_questions = 1
    }

    PostCallWithErrorResponse(ApiConfig.REPLACE_QUEST, payload).then((res) => {

      if (res?.json?.replaced_questions) {

        let quest = res?.json?.replaced_questions?.map((ques) => ({
          ...ques,
          text: 'New Question',
          type: 'MCQ',
          weight: 1,
        }))

        if (type == 'more like this') {

          setLocal(prev => ({
            ...prev,
            questions: [
              ...prev.questions.slice(0, index + 1),
              ...quest,
              ...prev.questions.slice(index + 1)
            ]
          }));

        }

        if (type == 'Replace') {

          const qs = [...local.questions];

          qs[index] = {
            ...quest[0]
          };
          setLocal({ ...local, questions: qs });

        }



      }

    })

  }



  return (
    <div className="" >

      <div className="panel-header" style={{ borderBottom: '1px solid var(--ui-border)', paddingBottom: '8px' , marginBottom:'3px',borderRadius:'8px 8px 8px 8px'}}>
        {local.status !== 'Deployed' && (
          <>

            <div className='w-100' style={{ width: '100%' }}>
              
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  width: '100%',
                  //  background: '#f3f4f6',
                  borderRadius: '6px',
                  padding: '0px 0px',
                  gap: '8px',
                  paddingBottom: '0'
                }}
              >
                <h4 className='fw-bold' style={{ fontSize: '14px', marginBottom: '1px', display: 'block',width:'140px',marginTop:'2px' }}>
                {
                  local?.id?"Update ":"Create "
                }
                  Quiz 
              </h4>
                {/* 1. Title Input */}
                <div style={{width:'100%'}}>
                <InlineTitleEditor
                initialTitle={local.title}
                onSave={(e)=>{
console.log(e);


                  const val = e;

                    if(val.length>50){
                      toastMsg('error','Title must be within 50 characters')
                      return 
                    }

                    const formattedTitle = val.length > 0 ? val.charAt(0).toUpperCase() + val.slice(1).toLowerCase() : '';
                    setLocal({ ...local, title: formattedTitle });
                }}
                />
                </div>

                {/* <input
                  id="quizTitle"
                  placeholder="TITLE"
                  value={local.title}
                  onChange={e => {
                    const val = e.target.value;

                    if(val.length>50){
                      toastMsg('error','Title must be within 50 characters')
                      return 
                    }

                    const formattedTitle = val.length > 0 ? val.charAt(0).toUpperCase() + val.slice(1).toLowerCase() : '';
                    setLocal({ ...local, title: formattedTitle });
                  }}
                  style={{
                    flex: 1,
                    border: '1px solid #e5e7eb',
                    background: '#fff',
                    outline: 'none',
                    borderRadius: '4px',
                    padding: '5px 10px',
                    fontSize: '11px',
                    fontWeight: '600',
                    color: '#1F222A',
                    textTransform: local.title ? 'none' : 'uppercase',
                    letterSpacing: local.title ? 'normal' : '0.05em',


                    background: '#f3f4f6',
                    borderRadius: '6px',
                    padding: '6px 8px',

                  }}
                /> */}

                {/* Duration + Buttons */}
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexShrink: 0 }}>

                  {/* 2. Duration Select */}
                  <select
                    id="quizDuration"
                    value={local.durationMinutes}
                    onChange={e =>
                      setLocal({
                        ...local,
                        durationMinutes: parseInt(e.target.value) || 0
                      })
                    }
                    style={{
                      border: '1px solid #e5e7eb',
                      background: '#fff',
                      borderRadius: '4px',
                      outline: 'none',
                      fontSize: '13px',
                      fontWeight: '500',
                    
                      cursor: 'pointer',
                      padding: '5px 8px',
                      flexShrink: 0,
                    }}
                  >
                    {DURATION_OPTIONS.map(d => (
                      <option key={d} value={d}>
                        {d} min
                      </option>
                    ))}
                  </select>

                  {/* 3. Buttons Container */}
                  <div style={{ display: 'flex', gap: '8px', alignItems: 'center', flexShrink: 0 }}>
                    {/* Reorder Button */}
                    <button className="btn btn-outline-primary" disabled={local.questions?.length<2} onClick={() => setIsOrder(true)}>
                      <ArrowUpDown size={14} />
                      Reorder
                    </button>

                    {/* Add/Edit Question Split Dropdown */}
                    <div className="add-q-split-wrapper">
                      <div className="add-q-split-btn btn btn-primary" onClick={() => setShowAddMenu(v => !v)} style={{ cursor: 'pointer' }}>
                        <span className="add-q-split-label">Add/Edit Question</span>
                        <button 
                          className="add-q-chevron-btn"
                        >
                          <ChevronDown size={14} />
                        </button>
                      </div>

                      {showAddMenu && (
                        <div className="add-q-menu">
                          <button className="add-q-menu-item" onClick={() => {
                            setIsEditQstn(false)
                            addQuestion(); setShowAddMenu(false); }}>
                            <Edit3 size={14} />
                            Manually
                          </button>
                          <button className="add-q-menu-item" onClick={() => { aiGenWrapperRef.current?.querySelector('button')?.click(); setShowAddMenu(false); }}>
                            <Sparkles size={14} />
                            Generate with AI
                          </button>
                        </div>
                      )}
                    </div>

                    {/* Off-screen AiGenerator — modal uses position:fixed so it still appears correctly */}
                    <div ref={aiGenWrapperRef} style={{ position: 'absolute', left: '-9999px', top: '-9999px', width: 0, overflow: 'hidden' }}>
                      <AiGenerator onImport={(ques) => { handleAiImport(ques) }}
                      setSelectedJobData={setSelectedJobData}
                      selectedJobData={selectedJobData}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
{/* taleeb */}
      <div
  className="panel-body"
  style={{
    padding: '16px',
    gap: '2px',
    display: 'flex',
    flexDirection: 'column',
    height: 'calc(100vh - 250px)',
    overflowY: 'auto',
    overflowX: 'hidden',
  }}
>
        {local.questions.map((q, idx) => (
          <div key={idx} className="dashboard-card" style={{ padding: '12px 16px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '1px', marginBottom: '8px' }}>
              <p className="font-size-base fw-bold" style={{ margin: 0, flex: 1 }}>{q?.q} </p>
              <div className="points-dropdown-wrapper">
                <span className="font-size-base fw-bold text-muted"></span>
                <select
                  className="points-select"
                  value={q.weight}
                  onChange={e => updateQ(idx, 'weight', parseFloat(e.target.value))}
                  title="Edit Question Points"
                >
                  {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(pt => (
                    <option key={pt} value={pt}>{pt} pt</option>
                  ))}
                </select>

                <div className="question-action-menu">
                  <button
                    className="btn-ghost"
                    onClick={(e) => { e.stopPropagation(); setActiveDropdown(activeDropdown === idx ? null : idx); }}
                  >
                    <Icons.More />
                  </button>

                  {activeDropdown === idx && (
                    <div className="context-menu" style={{ position: 'absolute', right: 0, top: '100%', zIndex: 20 }}>
                      {[
                        { label: 'Edit', icon: <Icons.Edit />, onClick: () => {
                          setIsEditQstn(true)
                          setEditQ(JSON.parse(JSON.stringify(q))); setEditIdx(idx); } },
                        //  { label: 'More Like This', icon: <Icons.Copy />, onClick: () => handleQuestionUpdateFromAi('more like this', idx, q.q, q?.topics || []) },
                        //  { label: 'Replace', icon: <Replace />, onClick: () => handleQuestionUpdateFromAi('Replace', idx, q.q, q?.topics || []) },
                        {
                          label: 'Delete', icon: <Icons.Trash />, onClick: () => {
                            const n = [...local.questions];
                            n.splice(idx, 1);
                            setLocal({ ...local, questions: n });
                          }, isDanger: true
                        }
                      ].map((item, i) => (
                        <button
                          key={i}
                          className={`context-menu-item text-base d-flex align-items-center ${item.isDanger ? 'danger' : ''}`}
                          onClick={() => { item.onClick(); setActiveDropdown(null); }}
                          style={{
                            gap: '8px',
                            width: '100%',
                            border: 'none',
                            background: 'transparent',
                            padding: '8px 12px',
                            cursor: 'pointer',
                            textAlign: 'left',
                            color: item.isDanger ? 'var(--color-danger-text)' : 'var(--brand-dark-grey)'
                          }}
                        >
                          <span className="font-size-h4 d-inline-flex justify-content-center" style={{ width: '16px' }}>
                            {item.icon}
                          </span>
                          {item.label}
                        </button>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
              {q.options.map((o, i) => {
                const isCorrect = o === q.correct_answer;
                return (
                  <span
                    key={i}
                    className="font-size-base"
                    style={{ color: isCorrect ? '#16a34a' : 'var(--color-dark-grey)' }}
                  >
                    {o}
                  </span>
                );
              })}
            </div>

            {/*  Rationale:in a box, and italic text */}
            {/* {q.rationale && (
               <div className="mt-2" style={{
                 padding: '8px 12px',
                 border: '1px solid var(--ui-border)',
                 borderRadius: '6px',
                 display: 'flex',
                 gap: '6px',
                 fontStyle: 'italic',
               
               }}>
                 <strong className="text-sm" style={{ fontStyle: 'normal' }}>Rationale:</strong>
                 <span className="text-sm" >{q.rationale}</span>
               </div>
             )} */}
          </div>
        ))}
      </div>

      <ReorderQuestionsList isOpen={isReOrder} onSave={(ques)=>{
        setLocal(prev=>({...prev, questions: ques}))
      }} questions={local?.questions} onClose={() => setIsOrder(false)} />

      {/* Sticky Action Bar */}
      <div className="sticky-action-bar" style={{ position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 1000 }}>
        <button className="btn btn-outline-primary" onClick={onCancel}>Cancel</button>
        <div style={{ display: 'flex', gap: '8px' }}>
          {local.status === 'Deployed' ? (
            <button className="btn btn-primary" onClick={() => onSave(local)} title="Save changes and close editor">Save & Update</button>
          ) : (
            <>
              {/* <button
                 className="btn btn-outline-primary"
                 onClick={() => setIsOrder(true)}
                 title={local.questions && local.questions.length > 0 ? "Reorder items" : "No questions to reorder"}
                 disabled={!local.questions || local.questions.length === 0}
               >Reorder</button> */}
              {/* Save Split Dropdown */}
              <div className="add-q-split-wrapper">
                <div className="add-q-split-btn btn btn-primary" onClick={() => setShowSaveMenu(v => !v)} style={{ cursor: 'pointer' }}>
                  <span className="add-q-split-label">Save</span>
                  <button className="add-q-chevron-btn">
                    <ChevronDown size={14} />
                  </button>
                </div>

                {showSaveMenu && (
                  <div className="add-q-menu" style={{ top: 'auto', bottom: 'calc(100% + 6px)' }}>
                    <button className="add-q-menu-item" title="Save work without publishing" onClick={() => { onSave({ ...local, status: 'Draft' }); setShowSaveMenu(false); }}>
                      <Save size={14} />
                      Save as Draft
                    </button>
                    <button className="add-q-menu-item" title="Publish to Assessment Library" onClick={() => { onSave({ ...local, status: 'Ready' });
                     setShowSaveMenu(false);
                   }}>
                      <BookCheck size={14} />
                      Save and Publish
                    </button>
                  </div>
                )}
              </div>
            </>
          )}
        </div>
      </div>

      {editQ && (
        <Modal title={<h4 className="fw-bold" style={{ margin: 0, fontSize: 'var(--font-size-h3) ' }}>{isEditQstn?'Edit':'Add'} Question</h4>} onClose={() => { setEditQ(null); setEditIdx(-1); }} dialogClassName="modal-h-650" footer={
          <div className="d-flex justify-content-between " style={{ gap: '1rem' }} >
            <button className="btn btn-outline-primary" onClick={() => { setEditQ(null); setEditIdx(-1); }}>Close</button>
            <button className="btn btn-primary" onClick={saveModalChanges}>Save</button>
          </div>
        }>
          <div className="margin-btn-input">
            <label className="form-label">Question Text</label>
            <textarea
              className={`font-size-base form-control my-custom-textarea ${isValided && !editQ?.q ? "redBorder" : ""}`}
              rows={3}
              value={editQ.q}
              onChange={e => setEditQ({ ...editQ, q: e.target.value })}
            />
          </div>
          <div className="margin-btn-input">
            <label className="form-label">Options (Select Correct)</label>
            {editQ.options.map((opt, i) => (
              <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <input type="radio" name="correctOpt" checked={editQ.correct_answer === opt} onChange={() => setEditQ({ ...editQ, correct_answer: opt })} />
                <input className={`font-size-base form-control margin-btn-input ${isValided && !opt ? "redBorder" : ""}`} style={{ padding: '0.4rem' }} value={opt}
                  onChange={(e) => {
                    const newOpts = [...editQ.options];
                    newOpts[i] = e.target.value;
                    setEditQ({ ...editQ, options: newOpts });
                  }}
                />
              </div>
            ))}
          </div>
          <div>
            <label className="form-label">Rationale</label>
            <textarea className={`font-size-base form-control `} rows={2} value={editQ.rationale || ''} onChange={e => setEditQ({ ...editQ, rationale: e.target.value })} />
          </div>
        </Modal >
      )}

      {aiModalOpen && (
        <AiWizardModal
          onClose={() => setAiModalOpen(false)}
          onImport={handleAiImport}
          difficulty={difficulty}
          setDifficulty={setDifficulty}
          initialTopic={local.title}
          selectedJobData={selectedJobData}
          setSelectedJobData={setSelectedJobData}
        />
      )}
    </div >
  );
};

// --- AI Wizard (Modal Version) ---
const AiWizardModal = ({ onClose, onImport, initialTopic, difficulty,
  setDifficulty,selectedJobData,setSelectedJobData }) => {
  const [step, setStep, activeDropdown, setActiveDropdown,] = useState('context'); // Start at context

  /* --- START: JD FLOW STATE (Copy for Live Project) --- */
  const [topicSource, setTopicSource] = useState('manual'); // 'manual' | 'jd'
  /* --- END: JD FLOW STATE --- */

  const [selectedTopics, setSelectedTopics] = useState([]);
  const [selectedSubTopics, setSelectedSubTopics] = useState([]);
  const [customTopic, setCustomTopic] = useState('');


  const [topics, setTopics] = useState([])

  const [isOpen, setISOpen] = useState(null); // For future use
  // Quiz Params
  const [count, setCount] = useState(5);

  const [duration, setDuration] = useState('30');

  const [questions, setQuestions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [regeneratingIndex, setRegeneratingIndex] = useState(-1);
  const [feedback, setFeedback] = useState('');

  // Validations
  const isTopicsValid = selectedTopics.length > 0 && selectedTopics.length <= 5;
  const isSubTopicsValid = selectedSubTopics.length <= 12; // Optional, but max 12

  const [subTopics, setSubTopics] = useState([])


  const getSubSubTopics = (topic) => {




    PostCallWithErrorResponse(ApiConfig.GET_SUB_TOPICS, {
      job_description: '',
      topics: selectedTopics
    }).then((res) => {

      if (res?.json?.sub_topics) {

        const allUnrecommendedSubtopics = res?.json.sub_topics.flatMap(
          item => item.unrecommended_subtopics
        );

        setSubTopics(allUnrecommendedSubtopics)
      }

    })

  }

  useEffect(() => {

    if (selectedTopics.length === 0) {
      setSubTopics([])
      return
    }

    const timer = setTimeout(() => {
      getSubSubTopics()
    }, 1000)

    return () => clearTimeout(timer);

  }, [selectedTopics])

  const availableSubTopics = useMemo(() => {
    const allSub = [];
    selectedTopics.forEach(t => {
      const job = JOB_DESCRIPTIONS.find(j => j.title === t);
      if (job) allSub.push(...job.subTopics);
    });
    return [...new Set(allSub)]; // Unique
  }, [selectedTopics]);

  const handleAddCustom = () => {
    if (customTopic.trim()) {
      setTopics(prev => [...prev, customTopic]);
      setCustomTopic('');
    }
  };

  const generate = () => {
    if (!isTopicsValid) return alert("Please select between 1 and 5 main topics.");
    setLoading(true);

    PostCallWithErrorResponse(ApiConfig.GET_QUIZ_QUES, {
      difficulty_level: difficulty,
      job_description: '',
      num_questions: count,
      topics: selectedSubTopics
    }).then((res) => {

      if (res?.json?.quiz?.quiz_questions) {
        setQuestions(res?.json?.quiz?.quiz_questions);

        setStep('review');
      }

      setLoading(false);

    })

    // Pass gathered context
    // const promptContext = `Topics: ${selectedTopics.join(', ')}. SubTopics: ${selectedSubTopics.join(', ')}`;
    // MockService.simulateAi('GET', { topic: promptContext, count }).then(res => {
    //   setQuestions(res.questions);
    //   setLoading(false);
    //   setStep('review');
    // });
  };

  const regenerate = (idx) => {
    MockService.simulateAi('REGENERATE', { feedback, topics: selectedTopics }).then(res => {
      const newQs = [...questions];
      newQs[idx] = res.question;
      setQuestions(newQs);
      setRegeneratingIndex(-1);
      setFeedback('');
    });
  };

  const remove = (idx) => {
    setQuestions(prev => prev.filter((_, i) => i !== idx));
  };

  const handleImport = () => {
    const appQuestions = questions.map(q => ({
      id: crypto.randomUUID(),
      text: q.text,
      type: 'MCQ',
      weight: 1,
      rationale: q.rationale,
      options: q.options,
    })).map(q => {
      q.correctOptionId = q.options[0].id;
      return q;
    });

    const questionsMap = questions?.map((ques) => {
      return {
        ...ques,
        weight: 1,
        type: "MCQ"
      }
    })

    onImport(questionsMap);
  };

  return (
    <Modal title="" onClose={onClose} size="800px" footer={null}>
      <div
      // style={{
      //   padding: '1rem 1.5rem 1.5rem 1.5rem',
      //   maxHeight: '70vh',
      //   overflowY: 'auto',
      //   display: 'flex',
      //   flexDirection: 'column',
      //   position: 'relative',
      // }}
      >

        <div
          style={{
            marginTop: '-5px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '1.5rem',
          }}
        >
          <h4 className="fw-bold font-size-h4">
            AI Question Generator
          </h4>

          {/* <div className="fw-bold" style={{ fontSize: 'var(--font-size-h4)' }}>
  AI Question Generator
</div> */}

          <button
            onClick={onClose}
            aria-label="Close"
            style={{
              background: 'transparent',
              border: 'none',
              fontSize: 'var(--font-size-h1)',
              cursor: 'pointer',
              lineHeight: 1,
              color: 'inherit',
              padding: 0,
            }}
          >
            ×
          </button>
        </div>

        {/* Step content here */}
        {step === 'context' && (
          <div>
            <h6 className="text-base fw-bold">1. Set Context (Topics from Job Descriptions)</h6>
            <div className="mb-4" style={{ marginTop: '-11px' }}>
              <label className="form-label">Select Main Topics (Max 5)</label>
              <div
                style={{
                  display: 'flex',
                  gap: '8px',
                  flexWrap: 'wrap',
                  marginBottom: '10px',
                }}
              >
                {topics.map((job) => (
                  <button
                    key={job}
                    onClick={() => {
                      if (selectedTopics.includes(job))
                        setSelectedTopics((p) => p.filter((t) => t !== job));
                      else if (selectedTopics.length < 5)
                        setSelectedTopics((p) => [...p, job]);
                    }}
                    className={`btn btn-sm ${selectedTopics.includes(job)
                      ? 'btn-primary'
                      : 'btn-outline-primary'
                      }`}
                    style={{ borderRadius: '20px' }}
                  >
                    {job}
                  </button>
                ))}
              </div>
              <div
                className="input-group"
                style={{ maxWidth: '300px', display: 'flex' }}
              >
                <input
                  className="form-control"
                  style={{
                    borderTopRightRadius: 0,
                    borderBottomRightRadius: 0,
                  }}
                  placeholder="Add custom topic..."
                  value={customTopic}
                  onChange={(e) => setCustomTopic(e.target.value)}
                />
                <button
                  className="btn btn-outline-primary"
                  style={{
                    borderTopLeftRadius: 0,
                    borderBottomLeftRadius: 0,
                    borderLeft: 0,
                  }}
                  onClick={handleAddCustom}
                >
                  <Icons.Plus />
                </button>
              </div>
            </div>

            {selectedTopics.length > 0 && (
              <div
                style={{
                  display: 'flex',
                  gap: '8px',
                  flexWrap: 'wrap',
                  padding: '10px',
                  background: '#f8f9fa',
                  borderRadius: '8px',
                  border: '1px solid #e2e8f0',
                  marginBottom: '1rem',
                  maxHeight: '300px',
                  overflow: 'scroll'
                }}
              >
                {subTopics.map((sub) => (
                  <button
                    key={sub}
                    onClick={() => {
                      if (selectedSubTopics.includes(sub))
                        setSelectedSubTopics((p) => p.filter((t) => t !== sub));
                      else if (selectedSubTopics.length < 12)
                        setSelectedSubTopics((p) => [...p, sub]);
                    }}
                    className={`badge text-base ${selectedSubTopics.includes(sub) ? 'badge-primary' : 'badge-secondary'}`}
                    style={{ cursor: 'pointer', border: 'none' }}
                  >
                    {sub}
                  </button>
                ))}
                <div className="text-muted small mt-1" style={{ width: '100%' }}>
                  {selectedSubTopics.length}/12 selected
                </div>
              </div>
            )}
          </div>
        )}

        {step === 'params' && (
          <div>
            <h4 className="fw-bold font-size-h4" style={{ marginTop: '-19px' }}>2. Quiz Parameters</h4>
            {loading ? (
              <div style={{ textAlign: 'center', padding: '3rem' }}>
                <div className="spinner-border text-primary mb-2" role="status"></div>
                <p className='text-base fw-normal'>
                  AI is crafting your questions based on selected topics...
                </p>
              </div>
            ) : (
              <div
                style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap' }}
              >
                <div style={{ flex: 1 }}>
                  <label className='form-label'>
                    Number of Questions
                  </label>
                  <select
                    className="form-select"
                    value={count}
                    onChange={(e) => setCount(e.target.value)}
                  >
                    <option value="3">3</option>
                    <option value="5">5</option>
                    <option value="10">10</option>
                    <option value="15">15</option>
                  </select>
                </div>

                <div style={{ flex: 1 }}>
                  <label className='form-label'>Difficulty Level</label>
                  <select
                    className="form-select"
                    value={difficulty}
                    onChange={(e) => setDifficulty(e.target.value)}
                  >
                    <option>Easy</option>
                    <option>Medium</option>
                    <option>Hard</option>
                  </select>
                </div>

                {/* <div style={{ flex: 1 }}>
                  <label className="form-label fw-bold">Duration (Minutes)</label>
                  <select
                    className="form-control"
                    value={duration}
                    onChange={(e) => setDuration(e.target.value)}
                  >
                    {DURATION_OPTIONS.map((d) => (
                      <option key={d} value={d}>
                        {d}
                      </option>
                    ))}
                  </select>
                </div> */}
              </div>
            )}
          </div>
        )}

        {step === 'review' && (
          <div style={{ maxHeight: '50vh', overflowY: 'auto' }}>
            <h4 className="fw-bold font-size-h4">3. Review & Edit</h4>
            {
              console.log(questions, "Amei")
            }
            {questions?.map((q, i) => (
              <div key={i} className="dashboard-card" style={{ marginBottom: '1rem', height: 'auto' }}>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    marginBottom: '0.5rem',
                    position: 'relative',
                  }}
                >
                  <span className="badge badge-primary">Question {i + 1}</span>

                  <span
                    className="three-dot-icon"
                    onClick={() => setISOpen(i)}
                  >
                    &#x22EE;
                  </span>

                  {isOpen === i && (
                    <div
                      style={{
                        position: 'absolute',
                        right: 0,
                        top: '100%',
                        background: 'white',
                        border: '1px solid var(--ui-border)',
                        borderRadius: '0.5rem',
                        boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                        zIndex: 20,
                        minWidth: '180px',
                        overflow: 'hidden',
                      }}
                    >
                      {/* <button className="dropdown-item" style={dropdownItemStyle}>
                <Icons.Edit style={{ color: 'var(--brand-primary)' }} /> Edit
              </button>
              <button className="dropdown-item" style={dropdownItemStyle}>
                <Icons.Copy style={{ color: '#8b5cf6' }} /> More Like This
              </button>
              <button className="dropdown-item" style={dropdownItemStyle}>
                <Icons.Replace style={{ color: '#f59e0b' }} /> Replace
              </button> */}
                      <button className="dropdown-item" style={dropdownItemStyle}
                        onClick={() => remove(i)}
                      >
                        <Icons.Trash className="text-danger" /> Delete
                      </button>
                    </div>
                  )}
                </div>

                <p style={{ margin: '0 0 0.5rem 0' }} className='text-base fw-bold'>{q?.q}</p>

                <div style={{ marginBottom: '0.5rem' }} className='text-base fw-normal text-muted'>
                  {q?.options?.map((o, idx) => (
                    <div key={idx} style={{ display: 'flex', gap: '0.5rem' }}>
                      <span>{String.fromCharCode(65 + idx)}.</span> <span>{o}</span>
                    </div>
                  ))}
                </div>

                {regeneratingIndex === i && (
                  <div
                    style={{
                      marginTop: '0.5rem',
                      padding: '0.5rem',
                      background: '#f8f9fa',
                      borderRadius: '0.5rem',
                    }}
                  >
                    <input
                      className="form-control"
                      style={{ marginBottom: '0.5rem' }}
                      placeholder="Feedback..."
                      value={feedback}
                      onChange={(e) => setFeedback(e.target.value)}
                    />
                    <button className="btn btn-primary btn-sm" onClick={() => regenerate(i)}>
                      Regenerate
                    </button>
                  </div>
                )}
              </div>
            ))}
          </div>
        )}




        {/* Buttons Row */}
        <div
          style={{
            fontWeight: 'bold',
            display: 'flex',
            justifyContent: 'space-between',
            marginTop: '1rem',
            gap: '0.5rem',
          }}
        >
          <button
            style={{ height: '40px', marginTop: '10px' }}
            className="btn btn-outline-primary fw-bold font-size-base"
            onClick={() => {
              if (step === 'review') setStep('params');
              else if (step === 'params') setStep('context');
              else onClose();
            }}
          >
            Back
          </button>

          <div>
            {step === 'context' && (
              <button
                style={{ marginTop: '10px', height: '40px', padding: '9.6px 19.2px' }}
                className="btn-primary"
                disabled={!isTopicsValid || !isSubTopicsValid}
                onClick={() => {
                  if (!selectedSubTopics.length) {
                    toastMsg('error', 'Please select at least one sub-topic to proceed.')
                    return
                  }
                  setStep('params')
                }}
              >
                Next
              </button>
            )}

            {/* {step === 'params' && (
              <button className="btn-primary" style={{ marginTop: '15px', padding: '9.6px 19.2px' }}
                onClick={generate}
                disabled={loading}

              >
                {loading ? 'Generating...' : 'Generate '}
              </button>
            )} */}

            {step === 'review' && (
              <button className="btn-primary" onClick={handleImport} style={{ marginTop: '15px' }}>

                Import {questions.length}
              </button>
            )}
          </div>
        </div>
      </div>
    </Modal>
  );
};

// --- Gradebook ---
const GradebookView = ({ assessment, submissions, antd, onBack, onAdjust }) => {
  const data = [{ studentName: "pankaj", score: '9', total: '10', date: new Date() },
  { studentName: "parvez", score: '9', total: '10', date: new Date() },
  { studentName: "Samir", score: '9', total: '10', date: new Date() },
  { studentName: "amir", score: '9', total: '10', date: new Date() },
  { studentName: "salman", score: '9', total: '10', date: new Date() },
  { studentName: "kureshi", score: '9', total: '10', date: new Date() }

  ]


  // submissions.filter(s => s.assessmentId === assessment.id).map(sub => {
  //   let score = 0, total = 0;
  //   const breakdown = assessment.questions.map(q => {
  //     const correct = sub.responses[q.id] === q.correctOptionId;
  //     const pts = parseFloat(q.weight);
  //     if (correct) score += pts;
  //     total += pts;
  //     return { correct, pts: correct ? pts : 0, w: q.weight };
  //   });
  //   return { ...sub, breakdown, score, total };
  // });

  const columns = [
    {
      title: "Name",
      dataIndex: "studentName",
      key: "studentName",
      align: "center",
      className: "font-size-base", // Applies to the cells
      onHeaderCell: () => ({ className: "font-size-base" }), // Applies to the header
      render: (text) => (
        <span title={text}>
          {text}
        </span>
      ),
    },
    {
      title: "Date",
      dataIndex: "submittedAt",
      key: "submittedAt",
      align: "center",
      className: "font-size-base",
      onHeaderCell: () => ({ className: "font-size-base" }),
      render: (date) =>
        date ? new Date(date).toLocaleDateString() : "-",
    },
    {
      title: "Score",
      key: "score",
      align: "center",
      className: "font-size-base",
      onHeaderCell: () => ({ className: "font-size-base" }),
      render: (_, record) => (
        <span
          style={{
            fontWeight: 700,
            color: "var(--brand-primary)",
          }}
        >
          {record.score}/{record.total}
        </span>
      ),
    },
  ];

  return (
    <div className="" style={{ paddingBottom: '80px' }}>
      <div className="panel-header" style={{ textAlign: 'center', marginBottom:'3px' }}>
        <div>
          <h4 className='font-size-h4' style={{ margin: 0, }}>Leaderboard: {assessment.title}</h4>
          <small className='font-size-base text-base text-muted'>Company: {assessment.groupCode}</small>
        </div>
        <button className="btn-primary" onClick={onAdjust} title="Modify question points">
          Modify Points
        </button>
      </div>

      <div className="panel-body">
        <Table
          size="large"
          columns={columns}
          dataSource={data}
          // onChange={handleChange}
          // pagination={false}
          className="grouplisttable overFlowTable interRegular "
        // tableLayout="fixed"

        // sticky={{ offsetHeader: 0 }}
        // rowSelection={true}
        />
        
      </div>

      <div className="sticky-action-bar" style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        width: '100%',
        backgroundColor: '#fff',
        padding: '15px 0',
        boxShadow: '0 -2px 10px rgba(0,0,0,0.1)',
        textAlign: 'center',
        zIndex: 1000
      }}>
        <button
          className="btn btn-outline-primary"
          style={{
            height: '40px',
            width: '80px',
            fontWeight: 'bold',
            marginLeft: '15px',
            fontSize: 'var(--font-size-base)',
            backgroundColor: 'transparent',
            color: '#007bff',
            border: '1px solid #007bff',
            borderRadius: '8px',

            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
          onClick={onBack}
        >
          Back
        </button>
      </div>
    </div>
  );
};

// --- View: Student Simulator ---
const StudentSimulatorView = ({ assessment, onClose, onSubmit }) => {
  const [responses, setResponses] = useState({});

  return (
    <div className="" >
      <div className="panel-header">
        <div>
          <h4 className='font-size-h4' style={{ margin: 0 }}>{assessment.title}</h4>
          <small className='font-size-base text-muted'>
            Mode: Candidate Preview • Company: {assessment.groupCode}
          </small>
        </div>
        <span className="font-size-base badge badge-primary text-muted" style={{ textTransform: 'none' }}>Preview Mode</span>
      </div>

      <div className="panel-body" style={{ background: '#f8f9fa' }}>
        {assessment.questions.map((q, idx) => (
          <div key={q.id} className="dashboard-card" style={{ marginBottom: '1rem', height: 'auto' }}>
            <div style={{ marginBottom: '0.5rem', display: 'flex', justifyContent: 'space-between' }}>
              <span className="font-size-base badge text-base text-muted" style={{ background: '#eee', textTransform: 'none' }}>Question {idx + 1}</span>
              <span className='font-size-base text-muted'>Points: {q.weight}</span>
            </div>
            <p style={{ margin: '0 0 1rem 0' }} className='font-size-base fw-medium'>{q?.q}</p>
            <div className='font-size-base' style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
              {q.options.map((opt, i) => (
                <label key={opt.id} style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '10px', border: '1px solid var(--ui-border)', borderRadius: '6px', background: '#fff', cursor: 'pointer' }}>
                  <input
                    type="radio"
                    name={q.id}
                    checked={q?.correct_answer === opt}
                    onChange={() => setResponses({ ...responses, [q.id]: q.correct_answer })}
                    style={{ accentColor: 'var(--brand-primary)' }}
                  />
                  <span className="fw-semibold text-muted">{String.fromCharCode(65 + i)}.</span>
                  <span>{opt}</span>
                </label>
              ))}
            </div>
          </div>
        ))}
      </div>


      <div className="sticky-action-bar" style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        background: '#fff',
        padding: '8px 13px',
        borderTop: '1px solid var(--ui-border)',
        display: 'flex',
        justifyContent: 'end',
        alignItems: 'center',
        zIndex: 1000
      }}>
        <button
          className="btn btn-outline-primary font-size-h4"
          onClick={onClose}
        >
          Close Preview
        </button>      </div>
    </div>
  );
};
/* ==============================================================================================
   5. MAIN APP CONTROLLER
   ============================================================================================== */

export default function App() {
  const [view, setView] = useState('dashboard');
  const [activeItem, setActiveItem] = useState(null);
  const [toast, setToast] = useState(null);

  const {adminData} = useContext(AppContext)

  // Data State
  const [assessments, setAssessments] = useState([]);
  const [submissions, setSubmissions] = useState([]);

  useEffect(() => {
    const style = document.createElement('style');
    // style.innerHTML = LYWO_CSS;
    document.head.appendChild(style);

    // Initial Seed Data with Diverse Samples
    const q1 = {
      id: 'q1', text: 'Which pattern best completes the sequence?', type: 'MCQ', weight: 1,
      rationale: 'Pattern recognition is key for problem solving.',
      options: [{ id: 'o1', text: 'Pattern A' }, { id: 'o2', text: 'Pattern B' }, { id: 'o3', text: 'Pattern C' }, { id: 'o4', text: 'Pattern D' }],
      correctOptionId: 'o1'
    };
    const q2 = {
      id: 'q2', text: 'Select the most appropriate response to the client email.', type: 'MCQ', weight: 1.5,
      rationale: 'Communication skills assessment.',
      options: [{ id: 'o5', text: 'Option A (Polite)' }, { id: 'o6', text: 'Option B (Direct)' }, { id: 'o7', text: 'Option C (Casual)' }, { id: 'o8', text: 'Option D (Technical)' }],
      correctOptionId: 'o5'
    };

    // Master Assessments (Drafts/Ready)
    const m1 = {
      id: 'm1', title: 'General Aptitude Test - Level 1', origin: 'Manual', status: 'Ready', repository: 'lywo',
      durationMinutes: 45, questions: [q1, q2],
      updatedAt: new Date('2023-12-05T10:00:00'), updatedBy: 'HR Admin'
    };

    const m2 = {
      id: 'm2', title: 'Senior Frontend Developer Assessment', origin: 'AI-Generated', status: 'Draft', repository: 'lywo',
      durationMinutes: 60, questions: [q1, q2, q1],
      updatedAt: new Date('2023-11-10T14:00:00'), updatedBy: 'AI Bot'
    };

    // Draft 1 (Company - Manual)
    const d1 = {
      id: 'd_new', title: 'Product Manager Case Study', origin: 'Manual', status: 'Draft', repository: 'company',
      durationMinutes: 90, questions: [q1],
      updatedAt: new Date('2023-12-01T09:30:00'), updatedBy: 'Sarah H.'
    };

    // Master 3 (Company - Bulk)
    const m3 = {
      id: 'm3', title: 'Workplace Safety & Compliance', origin: 'Bulk Upload', status: 'Ready', repository: 'company',
      durationMinutes: 30, questions: [q2, q2, q1],
      updatedAt: new Date('2023-12-20T16:45:00'), updatedBy: 'Compliance Team'
    };

    // Deployed Assessments (In Use) with "Position" field
    const dep1 = { ...m1, id: 'dep1', title: 'Eng. Batch 2024 - Aptitude', status: 'Deployed', groupCode: 'Tesla-Engineering', position: 'Junior Engineer', accessCode: 'APT-001', createdAt: new Date('2023-12-01') };
    const dep2 = { ...m2, id: 'dep2', title: 'Frontend Team - Q1 Skills Check', status: 'Deployed', groupCode: 'Tesla-Frontend', position: 'Senior React Dev', accessCode: 'RCT-002', createdAt: new Date('2023-12-10') };
    const dep3 = { ...m3, id: 'dep3', title: 'Factory Staff - Safety Cert', status: 'Deployed', groupCode: 'Tesla-Factory', position: 'Safety Officer', accessCode: 'SFT-101', createdAt: new Date('2023-12-15') };
    const dep4 = { ...d1, id: 'dep4', title: 'Leadership Evaluation - Managers', status: 'Deployed', groupCode: 'Tesla-Exec', position: 'Team Lead', accessCode: 'MGR-500', createdAt: new Date('2023-12-28') };

    setAssessments([m1, m2, d1, m3, dep1, dep2, dep3, dep4]);
    setSubmissions([
      { studentId: 's1', assessmentId: 'dep1', studentName: 'John Doe', submittedAt: new Date(), responses: { 'q1': 'o1', 'q2': 'o5' } },
      { studentId: 's2', assessmentId: 'dep2', studentName: 'Jane Smith', submittedAt: new Date(), responses: { 'q1': 'o1', 'q2': 'o5' } }
    ]);

    return () => {
      document.head.removeChild(style);
    };

  }, []);

  const notify = (msg) => { setToast(msg); setTimeout(() => setToast(null), 2500); };

  const handleEdit = (a) => {
    setActiveItem(
      {
      "id": "6ce4a16b-fffa-4d61-b963-79bd0c4350e6",
      "title": "TITLE",
      "origin": "Manual",
      "status": "Draft",
      "repository": "company",
      "durationMinutes": 30,
      "questions": [
        {
          "q": "In React, what is the primary purpose of PropTypes?",
          "options": [
            "To validate data types of component props",
            "To manage component lifecycle events",
            "To handle asynchronous API calls",
            "To define CSS styling rules"
          ],
          "correct_answer": "To validate data types of component props",
          "rationale": "PropTypes is specifically designed for runtime type checking of props in React components, ensuring data integrity.",
          "topics": [
            "PropTypes for Type Checking"
          ],
          "weight": 1,
          "type": "MCQ"
        },
        {
          "q": "Which JSX syntax correctly renders a component with conditional styling?",
          "options": [
            "<div className={isActive ? 'active' : 'inactive'}>Content</div>",
            "<div style={if(isActive){'active'}else{'inactive'}}>Content</div>",
            "<div class={isActive ? 'active' : 'inactive'}>Content</div>",
            "<div css={isActive ? 'active' : 'inactive'}>Content</div>"
          ],
          "correct_answer": "<div className={isActive ? 'active' : 'inactive'}>Content</div>",
          "rationale": "JSX uses className for CSS classes and requires JavaScript expressions in curly braces for dynamic values.",
          "topics": [
            "JSX Syntax and Usage"
          ],
          "weight": 1,
          "type": "MCQ"
        },
        {
          "q": "The __________ hook is used to read and subscribe to context values in functional components.",
          "options": [
            "useContext",
            "useContextState",
            "useContextValue",
            "useContextProvider"
          ],
          "correct_answer": "useContext",
          "rationale": "useContext is the standard React hook for accessing context values without prop drilling.",
          "topics": [
            "Context API for Global State"
          ],
          "weight": 1,
          "type": "MCQ"
        },
        {
          "q": "What does the useState hook return?",
          "options": [
            "Current state value and updater function",
            "Previous state snapshot and effect cleaner",
            "Context consumer and provider pair",
            "Memoized callback and dependencies array"
          ],
          "correct_answer": "Current state value and updater function",
          "rationale": "useState returns an array with two elements: the current state value and a function to update it.",
          "topics": [
            "State Management with Hooks"
          ],
          "weight": 1,
          "type": "MCQ"
        },
        {
          "q": "When should you use Context API instead of useState for state management?",
          "options": [
            "When sharing state across multiple nested components",
            "When handling form input validations",
            "When managing component-specific UI state",
            "When optimizing rendering performance"
          ],
          "correct_answer": "When sharing state across multiple nested components",
          "rationale": "Context API solves prop drilling by providing global state access, while useState is best for local component state.",
          "topics": [
            "Context API for Global State",
            "State Management with Hooks"
          ],
          "weight": 1,
          "type": "MCQ"
        }
      ],
      "updatedAt": "2026-01-30T06:31:40.823Z",
      "updatedBy": "User"
    }); setView('editor');
  };

  const handleSave = (updated) => {
    // Logic updated to respect the status passed from Editor (Draft vs Master)
    // setAssessments(prev => prev.map(a => a.id === updated.id ? { ...updated, updatedAt: new Date(), updatedBy: 'Current User' } : a));

    console.log(updated);

    if(!updated?.title || !updated?.questions?.length) {

      if(!updated?.title&&!updated?.questions?.length) toastMsg('error', 'Quiz must have a title and at least one question.')
      else if(!updated?.title) toastMsg('error', 'Quiz must have a title.');
      else if(!updated?.questions?.length) toastMsg('error', 'Quiz must have at least one question.');


      return
    }

    let payload = {
      "QuizId": updated?.id === 0 ? 0 : updated?.id,
      "quizName": updated?.title,
      "difficultyLevel": "Beginner",
      "duration": updated?.durationMinutes,
      "Status": updated?.status,
      questions: updated?.questions,
      email:adminData.email
    }

    PostCallWithErrorResponse(ApiConfig.CREATE_UPDATE_QUIZ, payload).then((res)=>{

      if(res?.json?.succeded){

        toastMsg('success', 'Quiz saved successfully!');


    setView(updated.status === 'Deployed' ? 'gradebook' : 'dashboard');

      }else{
        toastMsg('error', 'Failed to save quiz. Please try again.');
      }

    })

    // let msg = 'Saved';
    // // if (updated.status === 'Deployed') msg = 'Recalculated';
    // // else if (updated.status === 'Draft') msg = 'Saved as Draft';
    // // else if (updated.status === 'Ready') msg = 'Published';

    // notify(msg);
  };
  

  const handleDelete = (id) => {
    if (window.confirm('Delete?')) { setAssessments(prev => prev.filter(a => a.id !== id)); notify('Deleted'); }


  };


  const hnadleGetQuizDetials =(a,type)=>{

    simpleGetCall(ApiConfig.GET_QUIZ_DETAILS + a?.quizId).then((res) => {
      if(res?.succeded){

         let quiz = res?.response;

         console.log();

         quiz.id = a?.quizId;

         quiz.title=res?.response?.quizName


         quiz.durationMinutes=res?.response?.duration

         setActiveItem(quiz)
         setView('editor');

      }else{
        toastMsg('error', 'Failed to fetch quiz details. Please try again.');
     }           


     })

  }

  const handleNew = () => {
    // DIRECTLY OPEN EDITOR
    const newItem = {
      "id": 0,
      "title": "",
      "origin": "Manual",
      "status": "",
      "repository": "",
      "durationMinutes": 30,
      "questions": [],
      // "updatedAt": "2026-01-30T06:31:40.823Z",
      "updatedBy": "User"
    }
    setAssessments(prev => [newItem, ...prev]);
    setActiveItem(newItem);
    setView('editor');
  };

  const handleDownloadQuiz = (id, name) => {
  
  
      simpleGetCall(ApiConfig.DOWNLOAD_QUIZ_FILE + id).then((res) => {
  
        if (res?.succeded) {

  
          FileSaver.saveAs(
            "data:" +
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document" +
            ";base64," +
            res?.response,
            name + ".docx"
          );
        }
  
      })
  
    }

  return (
    <div className="">

      <div className="app-content" style={{
        // height: 'calc(100vh - 10px)',
        padding: '24px 24px',
        // overflow: 'scroll',
        display: 'flex',
        flexDirection: 'column',
        background: '#f4f7fa',
        marginTop: '0px'
      }}>
        {view === 'dashboard' && <DashboardView assessments={assessments} onEdit={handleEdit} onDelete={handleDelete} view={view} setView={setView} onNew={handleNew} 
         handleDownloadQuiz={handleDownloadQuiz}
        onAction={(a, type) => {

          hnadleGetQuizDetials(a,type)

         
        }}
        
        />}

        {view === 'active' && <DeployedView assessments={assessments} submissions={submissions} onDelete={handleDelete} view={view} setView={setView} onNew={handleNew}
        handleDownloadQuiz={handleDownloadQuiz}
          onAction={(a, type) => {

            hnadleGetQuizDetials(a,type)

           
          }} />}

        {view === 'editor' && <EditorView assessment={activeItem} onSave={handleSave} onCancel={() => setView(activeItem.status === 'Deployed' ? 'active' : 'dashboard')} />}

        {view === 'gradebook' && <GradebookView assessment={activeItem} submissions={submissions} onBack={() => setView('active')} onAdjust={() => setView('editor')}
        handleDownloadQuiz={handleDownloadQuiz}
        />}

        {/* Student Simulator: Close on Left (Back) */}
        {view === 'student' && activeItem && (
          <StudentSimulatorView
            assessment={activeItem}
            onClose={() => setView('active')}
            onSubmit={() => { setView('active'); notify('Submission Received'); }}
          />
        )}
      </div>

      {toast && <Toast msg={toast} />}
    </div>
  );
}

